import { GlyphStyleToggle } from "#glyph-style-toggle";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";

export function DrillPageGlyphStyleToggle({
  position = "top",
}: {
  position?: "top" | "card-header";
}) {
  const [displayMode, toggleDisplayMode] = useContextSelectors(
    NavContext,
    (c) => c.characterDisplayMode,
    (c) => c.toggleCharacterDisplayMode,
  );

  return (
    <GlyphStyleToggle
      className={
        position === "card-header"
          ? "absolute top-2.25 right-2.25 z-20"
          : "absolute top-2 right-3 z-20"
      }
      displayMode={displayMode}
      onPress={toggleDisplayMode}
    />
  );
}
